import YouTubePlayer from "youtube-player";
import Cookie from "js-cookie";

window.$ = window.jQuery;

const needPopup = () => {
  const now = new Date();
  const endTime = Cookie.get("popup-video");
  if (!endTime) return true;

  return now.getTime() > +endTime;
};

const hidePopup = () => {
  const now = new Date();
  now.setDate(now.getDate() + 30);

  Cookie.set("popup-video", now.getTime());
};

$(document).ready(function() {
  const player = YouTubePlayer("player", {
    videoId: "bRVj4TnQ2Lk",
    playerVars: {
      enablejsapi: 1,
      autoplay: 1,
      mute: 1,
      disablekb: 0,
      fs: 0,
      modestbranding: 0,
      rel: 0,
      showinfo: 0,
      hd: 1,
      autohide: 0,
      wmode: "transparent",
      iv_load_policy: 1,
      // hl: i18n.language, // set controls language
      cc_load_policy: 1, // force captions
      // cc_lang_pref: i18n.language, // captions language
    },
  });

  if (needPopup()) {
    setTimeout(() => {
      $(".backplate").addClass("backplate--open");
      $(".o-popup--video").addClass("o-popup--open");
      $("html").addClass("overflow-hidden");

      hidePopup();
    }, 2000);
  }

  $(".o-popup__close").on("click", function() {
    $(".backplate").removeClass("backplate--open");
    $(".o-popup--video").removeClass("o-popup--open");
    $("html").removeClass("overflow-hidden");
    player.stopVideo();
  });

  $(".backplate").on("click", function() {
    $(".backplate").removeClass("backplate--open");
    $(".o-popup--video").removeClass("o-popup--open");
    $("html").removeClass("overflow-hidden");
    player.stopVideo();
  });
});
